import styles from "./index.module.css";
import { useEffect,useRef } from "react";
const LonelinessAndCompanionship = (props) => {
    const svgRef = useRef(null);
  return (
    <svg
      width="1406"
      ref={svgRef}
      height="140"
      viewBox="0 0 1406 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${styles.svg} ${props.className}`}
    >
      <path
        d="M567.5 66.925C527 66.925 536.001 103.425 576 58.9252C580.495 53.9247 550.5 97.4243 590 76.4244C593 70.7456 595.5 69.9243 598.5 63.9243C600.525 59.8746 586 82.9243 583.5 86.4243C581 89.9243 626.538 48.3102 616 79.9243C607 106.924 655 63.9243 667 65.9243C626 75.4243 644.306 100.399 676 55.9242C707 12.4243 687 35.9242 660 87.4242C638.4 128.624 673.833 96.9243 694.5 76.4244"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`516.088px`
        }}
      />
      <path
        d="M841 43.4242C860.499 -1.57492 808.861 -6.98345 760 55.4243C718.505 108.424 738 167.924 838.499 82.9243"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`308.156px`
        }}
      />
      <path
        d="M2 85.4252C25 75.9243 95 33.4244 113 11.9243C138.617 -18.6741 50.5 49.2905 14 123.925C-1.43444 155.485 78 122.925 150.5 122.925"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`452.585px`
        }}
      />
      <path
        d="M153 71.5304C144 81.4252 143 97.9251 161 80.9251C173.3 69.3082 174.251 50.1737 154 70.4252C145 79.4252 183.5 79.4252 191.5 67.4252C199.5 55.4252 187.5 76.4252 180.5 84.4252C174.175 91.6534 194 73.4252 205.5 69.4252C226.725 62.0426 197 94.9251 216.5 87.4252C236.172 79.8589 236.5 77.493 240.5 76.9252C278.5 71.5304 252 55.9252 241 74.9252C236.741 82.2813 253.5 87.9251 277.5 76.9252C284.246 64.9252 289.5 57.9243 283.5 61.4243C293 54.9243 321.5 32.9244 325 19.4244C328.513 5.87234 289.822 43.8638 274.5 86.4251C256.5 136.424 311 73.9243 316 61.4243C317.752 57.0447 288 97.9243 326.999 78.4243C335.999 73.9243 342 59.4243 339 63.4243C336 67.4243 319.741 90.4535 326.999 84.9243C337.499 76.9252 366.75 57.4243 356.5 77.9243C345.5 99.9243 375.5 83.4252 387.5 75.4252C415.5 75.4252 406.5 54.4243 388 72.4243C380.44 79.7797 390.5 88.9243 423.5 75.9243C422.5 72.4243 428.75 65.9243 435 62.4243C447.5 55.4243 437.5 76.9243 441 72.4243C443.06 69.7761 444 55.5295 434.5 61.9243C405.5 81.4454 457 83.4243 419.5 97.9243C398.996 105.852 418.5 88.4243 463 74.4243C463 64.4243 486.349 56.3611 482 66.9243C475 83.9243 493 51.9243 470 65.4243C445.27 79.9398 497 82.9243 458 97.9243C435.243 106.677 464 85.9243 499.5 75.4252"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`1204.22px`
        }}
      />
      <path
        d="M863.298 71.528C854.298 81.4227 853.298 97.9227 871.298 80.9227C883.598 69.3058 884.55 50.1713 864.298 70.4227C855.298 79.4227 891.5 80.4219 899.5 68.4219C907.5 56.4219 898.897 73.5771 893 82.4219C888 89.9219 899.728 76.4588 910 69.9219C922.571 61.9219 911.518 85.0922 928.5 72.9219C958.5 51.4219 945.5 70.9219 950.5 78.9219C953.312 83.4219 971 80.9227 982 59.4218C985.871 51.8547 959.367 97.3288 941.5 122.922C923 149.422 956.059 99.5358 977.5 76.4219C1010.92 40.3909 1021.5 61.4231 998 75.4228C993.373 78.179 981.581 79.7426 976.5 80.9234C998 75.9221 1012 73.4231 1022.5 76.4219C1025.5 72.9223 1029.5 65.9231 1050 66.4231C1008 65.3987 1015 105.923 1057.5 58.9231C1060 56.1586 1032.5 96.4234 1070.5 76.4219C1072.5 74.9224 1077.1 70.5234 1079.5 64.9234C1082.5 57.9234 1071.45 75.4909 1065.5 84.4234C1058.5 94.9234 1104.95 52.4233 1098 75.4233C1096.63 79.9642 1081 102.925 1126 76.4233C1128.76 74.7991 1133.9 65.3233 1135.5 60.9233C1137.5 55.4233 1104 103.923 1152.5 73.9233C1137 93.4233 1154.5 93.4232 1167.5 71.9232C1177.78 54.9232 1161 61.9232 1153.5 71.4232C1147.58 78.9238 1184.5 80.327 1193.5 66.4233C1199 57.9233 1188 74.9227 1181 84.4233C1173.1 95.1416 1228.5 47.9233 1212.5 78.9233C1202.86 97.6096 1230.17 85.4234 1242 73.9234M1242 73.9218C1242 63.9218 1265.35 55.8586 1261 66.4218C1254 83.4218 1272 51.4218 1249 64.9218C1224.27 79.4373 1278 85.9233 1236.5 98.4233C1215.59 104.722 1243 86.9243 1279.5 75.9243C1292.83 55.591 1314.5 18.9243 1328.5 3.42388C1334.02 -2.69065 1307.5 28.4251 1271.5 91.4243C1262.18 107.737 1319.17 40.376 1308 75.9243C1303.13 91.4243 1325.08 77.9243 1337 62.4243C1345.74 51.0687 1303.5 103.425 1351.5 76.4243C1354.5 71.4254 1358.5 67.4233 1362.5 59.4243C1369.23 45.971 1333.45 105.074 1320 126.924C1312 139.924 1342.2 88.6939 1364.5 69.4243C1405 34.4243 1394 77.4243 1356 80.9243C1347.72 81.6872 1387.5 72.9243 1403.5 75.9233"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`1994.82px`
        }}
      />
      <path
        d="M327.5 47.4243C325.5 48.9243 323 51.4243 322 52.9243"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`7.80462px`
        }}
      />
      <path
        d="M1145.5 47.4243C1143.5 48.9243 1141 51.4243 1140 52.9243"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`7.80462px`
        }}
      />
      <path
        d="M1348.5 47.4243C1346.5 48.9243 1344 51.4243 1343 52.9243"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        style={{
            '--effect-path-length':`7.80462px`
        }}
      />
    </svg>
  );
};

export default LonelinessAndCompanionship
